function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import { isNumber, range } from 'lodash';
import Icon from "../../Icon/Icon";
import TextButton from "../../TextButton/TextButton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PageNumberNavigationLinkSpacer = () => /*#__PURE__*/_jsx("div", {
  className: "-mt-px px-4 pt-4 border-t-2 border-solid border-transparent text-center text-dark-grey font-heavy-font",
  children: "..."
});
const PageNumberNavigationLink = _ref => {
  let {
    number,
    pageNumber,
    setPageNumber,
    scrollPaginationElement = null
  } = _ref;
  const isCurrent = number === pageNumber;
  return /*#__PURE__*/_jsx(TextButton, {
    ariaCurrent: isCurrent ? 'page' : '',
    ariaLabel: "Go to page ".concat(number),
    className: cn('-mt-px px-4 pt-4 block text-center font-heavy-font', 'border-t-2 border-solid', isCurrent && "\n          text-current-med-blue border-current-med-blue\n          hover:text-current-med-blue hover:border-current-med-blue\n          focus:text-current-med-blue focus:border-current-med-blue\n        "),
    onClick: values => {
      setPageNumber(number);
      if (scrollPaginationElement) {
        scrollPaginationElement(values.currentTarget);
      }
    },
    role: "link",
    children: number
  });
};
PageNumberNavigationLink.propTypes = {
  number: PropTypes.number.isRequired,
  pageNumber: PropTypes.number.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  scrollPaginationElement: PropTypes.func
};
const PageNavigationLink = props => /*#__PURE__*/_jsx(TextButton, _objectSpread({
  className: "flex items-center space-x-3 -mt-px pt-4 pr-1 border-t-2 border-solid border-transparent",
  role: "link"
}, props));
PageNavigationLink.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};
const PageSelection = _ref2 => {
  let {
    className = '',
    pageNumber,
    setPageNumber,
    totalPageCount,
    scrollPaginationElement = null,
    showLabels = true
  } = _ref2;
  const nearStart = pageNumber - 3 <= 0;
  const nearEnd = pageNumber + 3 > totalPageCount;
  let pageOptions;
  if (totalPageCount < 7) {
    pageOptions = range(1, totalPageCount + 1);
  } else if (nearStart || nearEnd) {
    pageOptions = [1, 2, 3, null, totalPageCount - 2, totalPageCount - 1, totalPageCount];
  } else {
    pageOptions = [1, null, pageNumber - 1, pageNumber, pageNumber + 1, null, totalPageCount];
  }
  const isPreviousDisabled = pageNumber === 1;
  const isNextDisabled = pageNumber === totalPageCount;
  return /*#__PURE__*/_jsxs("div", {
    className: cn('flex justify-between items-center border-t border-solid border-dark-border-blue', className),
    children: [/*#__PURE__*/_jsxs(PageNavigationLink, {
      ariaLabel: "Go to previous page",
      dataTestId: "link-to-previous-page",
      disabled: isPreviousDisabled,
      onClick: values => {
        setPageNumber(pageNumber - 1);
        if (scrollPaginationElement) {
          scrollPaginationElement(values.currentTarget);
        }
      },
      children: [/*#__PURE__*/_jsx(Icon, {
        className: "text-action-blue fill-current",
        icon: "ArrowLeft"
      }), showLabels && /*#__PURE__*/_jsx("span", {
        className: "md:hidden lg:block text-action-blue font-heavy-font",
        children: "Previous"
      })]
    }), /*#__PURE__*/_jsx("ol", {
      className: cn('flex p-0'),
      children: pageOptions.map((number, index) => /*#__PURE__*/_jsx("li", {
        children: isNumber(number) ? /*#__PURE__*/_jsx(PageNumberNavigationLink, {
          number: number,
          pageNumber: pageNumber,
          setPageNumber: setPageNumber,
          scrollPaginationElement: scrollPaginationElement
        }) : /*#__PURE__*/_jsx(PageNumberNavigationLinkSpacer, {})
      }, number || "ellipsis-".concat(index)))
    }), /*#__PURE__*/_jsxs(PageNavigationLink, {
      ariaLabel: "Go to next page",
      dataTestId: "link-to-next-page",
      disabled: isNextDisabled,
      onClick: values => {
        setPageNumber(pageNumber + 1);
        if (scrollPaginationElement) {
          scrollPaginationElement(values.currentTarget);
        }
      },
      children: [showLabels && /*#__PURE__*/_jsx("span", {
        className: "md:hidden lg:block text-action-blue font-heavy-font",
        children: "Next"
      }), /*#__PURE__*/_jsx(Icon, {
        className: "text-action-blue fill-current",
        icon: "ArrowRight"
      })]
    })]
  });
};
PageSelection.propTypes = {
  className: PropTypes.string,
  pageNumber: PropTypes.number.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  totalPageCount: PropTypes.number.isRequired,
  scrollPaginationElement: PropTypes.func,
  showLabels: PropTypes.bool
};
export default PageSelection;
//# sourceMappingURL=PageSelection.js.map